export function todayInLosAngeles(): string {
  return new Intl.DateTimeFormat("en-CA", { timeZone: "America/Los_Angeles" }).format(new Date())
}

export function formatMoney(amount: number, currency = "USD"): string {
  return new Intl.NumberFormat("en-US", { currency, style: "currency" }).format(amount)
}

export function formatDateLabel(date: string | null | undefined): string {
  if (!date || !/^\d{4}-\d{2}-\d{2}$/.test(date)) return date ?? ""
  const parsed = new Date(`${date}T12:00:00`)
  if (Number.isNaN(parsed.getTime())) return date
  return new Intl.DateTimeFormat("en-US", {
    day: "numeric",
    month: "short",
    weekday: "short",
  }).format(parsed)
}

export function formatAddress(address: {
  street?: string
  street2?: string
  city?: string
  state?: string
  zip?: string
} | null | undefined): string {
  if (!address) return "—"
  const line1 = [address.street, address.street2].filter(Boolean).join(" ")
  const line2 = [address.city, address.state, address.zip].filter(Boolean).join(", ")
  return [line1, line2].filter(Boolean).join(", ") || "—"
}

export function formatModifiers(
  modifiers?: Array<{ attribute: string; values: string[] }>,
): string {
  if (!modifiers?.length) return ""
  return modifiers.map((m) => `${m.attribute}: ${m.values.join(", ")}`).join(" · ")
}

export function formatOptionPairs(
  pairs?: Array<{ attribute: string; name: string }>,
): string {
  if (!pairs?.length) return ""
  return pairs
    .map((pair) => (pair.attribute ? `${pair.attribute}: ${pair.name}` : pair.name))
    .filter(Boolean)
    .join(" · ")
}

export function windowLabel(window: string | null | undefined): string {
  if (!window) return "Unspecified"
  return window.replaceAll("_", " ")
}
